import React from 'react'
// libs
import styled, { keyframes } from 'styled-components'
// themes
import { colors } from 'themes'
// icons
import verginaSunUrl from 'src/icons/vergina-sun.svg?url'

interface Props {
  className?: string
  color?: string
  size?: number
  speed?: number
}

// The sun has 8-fold rotational symmetry, so every 90deg step lands exactly on the next set of rays
const snap = keyframes`
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(90deg);
  }
  50% {
    transform: rotate(180deg);
  }
  75% {
    transform: rotate(270deg);
  }
  100% {
    transform: rotate(360deg);
  }
`

const fade = keyframes`
  50% {
    opacity: 0.4;
  }
`

const Sun = styled.div<{ $color: string; $size: number; $speed: number }>`
  animation: ${snap} ${({ $speed }) => $speed}s cubic-bezier(0.7, 0, 0.3, 1) infinite;
  background-color: ${({ $color }) => $color};
  height: ${({ $size }) => $size}px;
  -webkit-mask: url(${verginaSunUrl}) center / contain no-repeat;
  mask: url(${verginaSunUrl}) center / contain no-repeat;
  width: ${({ $size }) => $size}px;

  @media (prefers-reduced-motion: reduce) {
    animation: ${fade} 2s ease-in-out infinite;
  }
`

const VerginaLoader: React.FC<Props> = ({ className, color = colors.purple300, size = 48, speed = 1.8 }) => (
  <Sun aria-label='Loading' className={className} role='progressbar' $color={color} $size={size} $speed={speed} />
)

export default VerginaLoader
